import axiosInstance from "../axiosInstance";
const BASE_URL = process.env.REACT_APP_API_URL;
const STAGE = process.env.REACT_APP_API_STAGE;

export const getUser = async () => {
  try {
    const response = await axiosInstance.get(
      BASE_URL + `v1/${STAGE}/dashboard/user-get`
    );
    console.log(`RES`, response);
    return response.data;
    return {};
  } catch (error) {
    console.log(error);
  }
};

export const postUser = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      BASE_URL + `v1/${STAGE}/dashboard/user-post`,
      payload
    );
    return response.data;
  } catch (error) {
    console.log(`ERR-POST-USER`, error);
  }
};

export const updateUserApi = async (payload: any) => {
  try {
    const response = await axiosInstance.put(
      BASE_URL + `v1/${STAGE}/dashboard/update-user`,
      payload
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
